<template>
  <div class="input-group select2-input-container">
    <select ref="select2" class="form-control input-sm"></select>
  </div>
</template>

<script>
export default {
    name: "select2",
    props: {
      endpoint: {
        type: String,
        required: true
      },
      value: {
        type: Object,
        required: false
      },
      dropdownParent: {
        type: String,
        default: "body"
      },
      placeholder: {
        type: String,
        default: ""
      },
      attributes: {
        type: Object,
        default: () => ({})
      },
      showSearchBar: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      renderMethod: {
        type: Function,
        default: (state) => {
          if (!state.id) {
            return "Chargement des résultats...";
          }
          return $(`<span>${state.text}<span>`);
        }
      }
    },
    data(){
      return {
        items: [],
        selectedItem: this.value,
      }
    },
    watch: {
      value: function(val){
        if(val == null){
          $(this.$refs["select2"]).html("");
        } else {
          $(this.$refs["select2"]).html(`<option value="${this.value.id}" selected>${this.value.text}</option>`)
        }
      }
    },
    mounted(){
      this.init();
    },
    methods:{
      init(){
        const that = this;
        
        if(this.value !== undefined){
          $(this.$refs["select2"]).html(`<option value="${this.value.id}" selected>${this.value.text}</option>`)
        }

        let select2 = $(this.$refs["select2"]).select2({
          language: "fr",
          theme: "bootstrap",
          ajax: {
            url: that.endpoint,
            dataType: 'json',
            data: function (params) {
              let attrs = {
                search: params.term,
                page: params.page || 1
              };

              Object.assign(attrs, that.attributes);

              return attrs
            },
            processResults: function (data) {
              return data;
            }
          },
          placeholder: this.placeholder,
          allowClear: true,
          dropdownParent: $(that.dropdownParent),
          searchInputPlaceholder: "Rechercher...",
          templateResult: that.renderMethod,
          dropdownCssClass : that.showSearchBar ? '' : 'no-search',
          disabled: that.disabled
        }).on("select2:select", function(data){
          var dat = data.params.data;
          that.selectedItem = dat;
          that.$emit("selected", dat);
          that.$emit('input', dat);
        }).on("select2:clear", function(data){
          that.selectedItem = null
          that.$emit("clear");
          that.$emit('input', {id: null, text: ""});
        }).on("select2:close", function(){
          that.$emit("closed");
        });

        $(".select2-selection.select2-selection--single").addClass("input-sm")
        $(".select2.select2-container.select2-container--bootstrap").css("width", "100%")
      },
      focus() {
        $(this.$refs["select2"]).select2("open");
      },
      clearSelection() {
        $(this.$refs["select2"]).val(null).trigger('change');
      },
      close() {
        $(this.$refs["select2"]).select2("close");
      }
    }
}
</script>
<style lang="scss">
@import '~select2-bootstrap-theme/dist/select2-bootstrap.min.css';

.no-search .select2-search {
  display:none !important;
}
</style>